// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/super_chatbots/index.css
// module id = 2279
// module chunks = 0